<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
        <div class="container">
            <h2 >Download Songs</h2>
        </div>
    </div><!-- End Breadcrumbs -->
    <!-- ======= Services Section ======= -->
    <section id="services" class="services">
        <div class="container" data-aos="fade-up">

            <!-- <div class="section-title">
                <h2>Services</h2>
                <p>Download songs</p>
            </div> -->

            <div class="row" >
                <div class="col-lg-4 col-md-6 align-items-stretch" *ngFor="let song of songsList | async" data-aos="zoom-in" data-aos-delay="100">
                    <div class="icon-box">
                        <div class="icon"><i class="bx bx-music"></i></div>
                        <h4><a href="" class="marathi-font">{{song.title}}</a></h4>
                        <h6 *ngIf="song.songsid != 18" class="marathi-font">प्रस्तुती - महानुभाव परमार्ग अध्ययन मंदिर, नागपूर</h6>
                        <h6 *ngIf="song.songsid == 18" class="marathi-font">प्रस्तुती - Unknown</h6>
                        <audio controls src='{{"../assets/"+song.url}}' ></audio> 
                        <p><a class="default-button" [href]='"../assets/"+song.url' [download]="song.title+'.mp3'"><i class="bi bi-download"></i> Download</a></p>
                    </div>
                </div>
            </div>
            

        </div>
    </section><!-- End Services Section -->
</main>